import { IconProps } from "../../utils/global-types/global-types";

const AttachmentInputIcon = ({ className, ...rest }: IconProps) => {
  return (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-4 h-4"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M9 1.5C4.86 1.5 1.5 4.86 1.5 9s3.36 7.5 7.5 7.5 7.5-3.36 7.5-7.5S13.14 1.5 9 1.5m3.278 9.263-1.665 1.665a2.062 2.062 0 0 1-3.518-1.455c0-.548.218-1.073.607-1.456L8.76 8.46a.566.566 0 0 1 .795 0 .566.566 0 0 1 0 .795l-1.057 1.057a.925.925 0 0 0 0 1.32.937.937 0 0 0 1.327 0l1.665-1.665a2.44 2.44 0 0 0-3.45-3.45L6.225 8.333a1.99 1.99 0 0 0 0 2.835.566.566 0 0 1 0 .796.566.566 0 0 1-.795 0 3.04 3.04 0 0 1-.93-2.205c0-.84.322-1.628.915-2.22L7.23 5.723a3.57 3.57 0 0 1 5.04 0 3.565 3.565 0 0 1 .008 5.04"
    ></path>
  </svg>
  );
};

export default AttachmentInputIcon;